import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { SortOrderDirection } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export interface Args {
	prop: string;
	selectedProp: string;
	selectedOrder: SortOrderDirection;
	changeProp: (prop: string) => void;
	changeOrder: (order: SortOrderDirection) => void;
	name?: string; // not used if yield-ing
}

interface TableSorterComponentInterface<T> {
	Args: T;
	Blocks: { default: [] }; // this is needed for yield
}

export default class TableSorterComponent extends Component<TableSorterComponentInterface<Args>> {
	get isActive() {
		return this.args.prop === this.args.selectedProp;
	}

	get order() {
		return this.isActive ? this.args.selectedOrder : 'asc';
	}

	get sortIconName() {
		return this.order === 'asc' ? 'ChevronUp' : 'ChevronDown';
	}

	@action
	sort() {
		if (this.isActive) {
			const newOrder = this.args.selectedOrder === 'asc' ? 'desc' : 'asc';
			this.args.changeOrder(newOrder);
		} else {
			this.args.changeProp(this.args.prop);
			this.args.changeOrder('asc');
		}
	}
	<template>
		<a
			role="button"
			class="table-sorter table-sorter--{{this.order}}
				{{if this.isActive 'table-sorter--active'}}"
			{{on "click" this.sort}}
		>
			{{#if (has-block)}}
				{{yield}}
			{{else}}
				{{@name}}
			{{/if}}
			<CommonUiIconComponent @name={{this.sortIconName}} @size="xs" />
		</a>
	</template>
}
